/* eslint-disable react/no-children-prop */
import { ChannelIcon } from '@weareopenr/component-library';
import { Link } from 'react-router-dom';
import JustEatLogo from 'src/assets/images/justeat-logo.svg';
import UberEatsLogo from 'src/assets/images/ubereats-logo.png';
import deliverooLogo from 'src/assets/images/deliveroo-logo.png';
import { IVenuePublishedChannels } from 'src/api/getVenues/types';
import styles from './mapVenuesToTable.module.scss';

const getChannelLogo = (channelName: string) => {
  switch (channelName) {
    case 'Just Eat':
      return <img className={styles['channel-logo']} src={JustEatLogo} alt={channelName} />;
    case 'Uber Eats':
      return <img className={styles['channel-logo']} src={UberEatsLogo} alt={channelName} />;
    case 'Deliveroo':
      return <img className={styles['channel-logo']} src={deliverooLogo} alt={channelName} />;
    default:
      return <ChannelIcon />;
  }
};

export const getPublishedMenusFormattedData = (publishedChannels: IVenuePublishedChannels[]) => {
  return (
    <>
      {publishedChannels.map((channel) => (
        <div key={channel.external_system_id} className={styles['published-channel-row']}>
          {getChannelLogo(channel.name)}
          <div className={styles['menus-container']}>
            <div>{channel.name}</div>
            <div className={styles['published-menus-list']}>
              {channel.menus.map((menu) => (
                <Link
                  className={styles['menu-link']}
                  key={menu.menu_id}
                  title={menu.name}
                  to={`/menus/${menu.menu_id}`}
                  data-testid="OptionListItemLinks"
                  onClick={(e) => e.stopPropagation()}
                >
                  {menu.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
